import { makeApiRequest } from '@/src/lib/api-request'
import { useQuery } from '@tanstack/react-query'

interface Country {
  id: string
  iso: string
  dialCode: string
  name: string
}

export const useCountriesQuery = () => {
  return useQuery({
    queryKey: ['countries'],
    queryFn: async () => {
      const response = await makeApiRequest({
        method: 'GET',
        url: '/MasterData/getAllCountry',
        isAuthenticated: false,
        fallbackError: 'Error while fetching countries',
        data: {},
        isV3Api: true,
      })

      const data: Country[] = response.response
      return data as Country[]
    },
    refetchOnWindowFocus: false,
  })
}
